export default {
  root: ({ props, context, parent, instance }) => ({
    class: [
      // Font
      'font-sans leading-none',
      'text-xs',
      { 'xl:text-sm': !instance.$attrs['no-label'] },
      'w-full',

      // Flex
      { 'flex-1 w-[1%]': parent.instance.$name == 'InputGroup' },

      // Spacing
      'm-0 h-12',
      {
        'px-4 py-4': props.size == 'large',
        'px-2 py-2': props.size == 'small',
        'p-3': props.size == null,
        '!h-8 4xl:h-12': instance.$attrs['boq-input'],
      },
      {
        '!h-8': parent.instance.$attrs['date-picker'] && parent.instance.$attrs['display-inline'],
      },
      {
        '4xl:px-3 4xl:pt-7 pt-6':
          parent.instance.$attrs['date-picker'] &&
          !parent.instance.$attrs['display-inline'] &&
          context.filled,
      },

      // Shape
      { 'rounded-lg': parent.instance.$name !== 'InputGroup' && !instance.$attrs['boq-input'] },
      { rounded: instance.$attrs['boq-input'] },
      {
        'first:rounded-l-md rounded-none last:rounded-r-md': parent.instance.$name == 'InputGroup',
      },
      { 'border-0 border-y border-l last:border-r ': parent.instance.$name == 'InputGroup' },
      { 'first:ml-0 -ml-px': parent.instance.$name == 'InputGroup' && !props.showButtons },

      // Colors
      'text-txt-800',
      'placeholder:text-txt-600',
      'bg-transparent',
      'border-2',
      'focus:border-blue-400',
      {
        'border-border-border-300':
          !props.invalid &&
          !instance.$attrs['has-text'] &&
          !parent.instance.$data['d_value'] &&
          !instance.$attrs['borderless'] &&
          !instance.$attrs['no-label'],
      },
      {
        'border-black':
          instance.$attrs['has-text'] &&
          !instance.$attrs['no-label'] &&
          !instance.$attrs['borderless'] &&
          !context.disabled,
      },
      {
        'border-black': parent.instance.$data['d_value'] && !context.disabled,
      },
      {
        'border-none':
          instance.$attrs['borderless'] ||
          instance.$attrs['search'] ||
          parent.instance.$name == 'InputGroup',
      },
      {
        'border-border-border-300':
          (instance.$attrs['no-label'] && instance.$attrs['has-text']) ||
          (instance.$attrs['no-label'] && !instance.$attrs['has-text']),
      },

      // Invalid State
      {
        'border-red-500 focus:border-red-500':
          props.invalid && !instance.$attrs['universal-item-search'],
      },

      // States
      'focus:outline-none focus:outline-offset-0 focus:ring-0 focus:shadow-none',
      {
        'opacity-40 select-none cursor-not-allowed': context.disabled,
      },

      // Filled State *for FloatLabel
      { filled: parent.instance?.$name == 'FloatLabel' && context.filled },

      // Misc
      'appearance-none',
      'transition-colors duration-200',
    ],
  }),
};
